<template>
  <section
    class="space-y-4"
  >
    <OrderHeader
      v-if="!loading"
      :order="order"
    />

    <spinner :loading="loading" />

    <div class="row orders-empty d-none d-md-none d-sm-none d-lg-block" v-if="error != null">
      <div class="mt-5 col-12">
        <h4 class="text-center orders-empty" v-html="error"></h4>
      </div>
    </div>

    <div class="row orders-empty d-lg-none" v-if="error != null">
      <div class="col-12">
        <p class="text-center orders-empty" v-html="error"></p>
      </div>
    </div>

    <div class="w-full pb-2" v-if="products">
      <OrderItemDetail
        v-for="(product, index) of products"
        :key="index"
        :product="product"
        :workflows-config="workflowsConfig"
        :products-count="products.length"
        :order-cod="order.orderNr"
      />
    </div>

  </section>
</template>

<script>
import namespace from '../../vuex/namespace'
import { mapState, mapActions } from 'vuex'
import OrderHeader from './Header'
import Spinner from '../Spinner/Spinner'
import OrderItemDetail from '@/components/Orders/OrderItemDetail'
import { findGeneralConfigWorkflowMappers } from '@/repositories/generalConfig'

export default {
  name: 'OrdersDetail',
  data () {
    return {
      sku: null,
      productId: null,
      invoice: {},
      manual: {},
      attendance: false,
      aux: true,
      workflowsConfig: []
    }
  },
  computed: {
    ...mapState(namespace.ORDER, ['order', 'products', 'loading', 'error']),
    ...mapState(namespace.ROUTE, ['params'])
  },

  created () {
    this.init()
  },

  mounted () {
    if (this.order == null || this.order.orderNr !== this.$route.params.id) {
      this.setOrderNumber(this.$route.params.id)
    }
    this.scroll()
  },
  components: {
    OrderHeader,
    Spinner,
    OrderItemDetail
  },
  methods: {
    ...mapActions(namespace.ORDER, ['setOrderNumber']),

    async init () {
      this.workflowsConfig = await this.getWorkflowsConfig()
    },

    scroll () {
      window.scrollTo({
        top: 0,
        left: 0,
        behavior: 'smooth'
      })
    },

    async getWorkflowsConfig () {
      try {
        const workflowsConfig = await findGeneralConfigWorkflowMappers()
        if (!workflowsConfig || !workflowsConfig.config || !workflowsConfig.config.workflowsMapper) {
          return []
        }
        return workflowsConfig.config.workflowsMapper
      } catch (error) {
        return []
      }
    }
  }
}
</script>
<style>
  @import 'https://sac-dbm.ascbrazil.com.br/public/chat/new/18/chatFlut.css';
  @import 'https://fonts.googleapis.com/css?family=Source Sans Pro';
</style>
